import { useNavigate, useParams } from 'react-router-dom';
import './oildetail.css';

const jaggeryData = {
  jagpow: {
    name: 'Jaggery Powder',
    image: '/images/sugar/jagpow.webp',
    description: 'Jaggery Powder, known as Vellam Podi (வெல்லம் பொடி) in Tamil, is made by boiling and evaporating sugarcane juice—primarily from farmlands in districts like Erode, Karur, and Thanjavur. Unlike refined sugar, it is prepared using traditional iron pans and wooden fire, without chemicals or additives.Tamil people consider jaggery powder a natural sweetener that supports digestion, detoxification, and helps boost iron levels. It is often added to kashayam, sweets, porridge (kanji), and Pongal dishes. Elders recommend it for treating cold, cough, and fatigue, believing it strengthens the body and balances energy, especially during seasonal changes.',
  },
  jagcube: {
    name: 'Jaggery Cubes',
    image: '/images/sugar/jagcube.webp',
    description: 'Jaggery Cubes, locally called Achu Vellam (அச்சு வெல்லம்), are made by boiling fresh sugarcane juice—sourced from regions like Karur, Erode, and Namakkal—until it thickens and is poured into traditional wooden or metal moulds to set into solid blocks.In Tamil households, jaggery cubes are considered a symbol of purity and wellness. They are believed to cleanse the blood, improve digestion, and provide instant energy. Often offered during festivals, temple rituals, and after meals, achu vellam is also used in payasam, pongal, and herbal drinks (kashayam) as a natural, iron-rich sweetener trusted across generations.',
  },
  jagballs: {
    name: 'Jaggery Balls',
    image: '/images/sugar/jagballs.webp',
    description: 'Jaggery Balls, known as Urundai Vellam (உருண்டை வெல்லம்) in Tamil, are made by boiling fresh sugarcane juice and shaping the thickened syrup into round balls while it cools. This form is common in villages across Thanjavur, Erode, and Salem, where jaggery is handmade using traditional firewood furnaces.Tamil people value jaggery balls for their natural sweetness and medicinal properties. They are believed to strengthen the body, purify the blood, and help in relieving cough, cold, and menstrual discomfort. Often consumed as a post-meal digestive, or mixed with groundnuts or dry ginger, jaggery balls are a trusted home remedy and an everyday energy booster.',
  },
  crystals: {
    name: 'Palm Sugar Crystals',
    image: '/images/sugar/crystals.webp',
    description: 'Palm Sugar Crystals, known as Panam Kalkandu (பனம் கல்்கண்டு) in Tamil, are made from the sap of palmyra trees grown in regions like Thoothukudi, Tirunelveli, and Ramanathapuram. The sap is collected early in the morning, boiled traditionally in clay pots, and crystallized into small, sweet, rock-like chunks.In Tamil homes, palm sugar crystals are cherished for their cooling effect, and are often used in Siddha medicine and home remedies. They are believed to soothe the throat, reduce body heat, and boost energy. Commonly added to herbal teas (kashayam), milk, or offered to children and elders, Panam Kalkandu is a natural sweetener rich in iron, calcium, and minerals.',
  },
  palmjag: {
    name: 'Palm Jaggery',
    image: '/images/sugar/palmjag.webp',
    description: 'Palm Jaggery, known as Karuppatti (கருப்பட்டி) in Tamil, is made from the sap of palmyra trees (panai maram) found in southern Tamil Nadu, especially in Tirunelveli, Thoothukudi, and Madurai. The sap is collected before sunrise, boiled over firewood, and then poured into moulds to solidify—without any chemicals or additives.Tamil people revere Karuppatti as a natural medicine, believed to purify blood, strengthen bones, and boost immunity. Its traditionally used in sweets, herbal drinks, and postpartum care. Its warm nature makes it ideal during monsoons and winters, and it’s trusted for relieving menstrual cramps, respiratory issues, and fatigue—a true healing sweetener passed down through generations.',
  },
};


const JaggeryDetail = () => {
  const { type } = useParams();
  const jaggery = jaggeryData[type];
  const navigate = useNavigate();
  const goToProducts = () => {
        navigate('/sugars');
    };

  if (!jaggery) return <h2>Jaggery product not found</h2>;

  return (
    <section
      className="sesame-section"
      style={{ backgroundImage: `url(${jaggery.image})` }}
    >
      <div className="sesame-content">
        <div className="text-content">
          <button className='back-btn-viewmore' onClick={goToProducts}>⟵ Back to Jaggery Products</button>
          <h2>{jaggery.name}</h2>
          <p>{jaggery.description}</p>
        </div>
        <div className="button-box">
        <button className="enquire-btn">ENQUIRE NOW</button>
      </div>
      </div>
      
    </section>
  );
};

export default JaggeryDetail;
